import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArticle = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-5 14H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z" />
  </SvgIcon>
);

export default IconArticle;



// WEBPACK FOOTER //
// ./src/components/icons/IconArticle.js